// extracted by mini-css-extract-plugin
module.exports = {"CharacterCard":"CharacterCard_CharacterCard__sIw9d","characterImage":"CharacterCard_characterImage__2hIX3","imgWrapper":"CharacterCard_imgWrapper__1CwYO"};